import { render, staticRenderFns } from "./IconModal.vue?vue&type=template&id=01fabd52&lang=pug"
import script from "./IconModal.vue?vue&type=script&lang=js"
export * from "./IconModal.vue?vue&type=script&lang=js"
import style0 from "./IconModal.vue?vue&type=style&index=0&id=01fabd52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports